import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Button from "designs/v1/components/Button";
import { useDispatch, useSelector } from 'react-redux';
import { setShowJointholderModal, updateJointholderFlowScreen } from '../../../../../redux';
import axios from 'axios';
import { useHistory } from "react-router-dom";

function AddJointHolderModal() {
    const dispatch = useDispatch();
    const history = useHistory();
    const { showJointholderModal, showJointholderFlow } = useSelector(state => state.jointholder)
    const stages = useSelector(state => state.navigation.stagesData)




    const getStages = () => {
        console.log('secound_holder', stages)
        if (stages) {
            const { secound_holder, thrid_holder } = stages;
            console.log('secound_holder', secound_holder)
            if (secound_holder.consent == 1) {
                console.log('hello there')
                history.push('/joint-holder')
                dispatch(updateJointholderFlowScreen(true))
                dispatch(setShowJointholderModal(false))
            }
        }
    }

    useEffect(() => {
        setTimeout(() => {
            getStages()
        }, 300)
    }, [])



    const [showModal, setShowModal] = useState(false)


    useEffect(() => {
        if (showJointholderFlow === null) {
            dispatch(setShowJointholderModal(true))
        }
    }, [showJointholderFlow])

    useEffect(() => {
        setShowModal(showJointholderModal)
    }, [showJointholderModal])

    const onHide = () => {
        dispatch(setShowJointholderModal(false))
    }



    // let stages = useSelector(state => state.navigation.stagesData)

    // const getStages = () => {
    //     if(stages){
    //         const { secound_holder, thrid_holder } = stages;
    //         if(secound_holder.consent){
    //             dispatch(updateJointholderFlowScreen(true))
    //         }
    //         if(thrid_holder.consent){
    //             dispatch(updateJointholderFlowScreen(true))
    //         }
    //     }
    // }

    // useEffect(() => {
    //     getStages();
    // },[stages])

    const submitToApi = async (value, holder = 2) => {
        const portal_domain = window.sessionStorage.getItem("portal_domain");
        const API_URL = portal_domain
            ? portal_domain.substring(0, portal_domain.length - 1)
            : "";
        const token = window.sessionStorage.getItem("token");
        const headers = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                Authorization: `Basic ${token}`,
            },
        };
        let formData = new FormData();
        formData.append('confirmation', value);
        formData.append('holder', holder);
        try {
            const resp = await axios.post(
                `${API_URL}/api/method/kyc_customizations.apis.joint_holder.joint_holder_confirmation.endpoint`,
                formData,
                headers
            );

        } catch (error) {
            console.log(error)
        }
    }

    const handleYes = () => {
        submitToApi(true)
        dispatch(updateJointholderFlowScreen(true))
        onHide();
        history.push('/joint-holder')

    };

    const handleNo = () => {
        onHide();
        dispatch(updateJointholderFlowScreen(false));
    };

    return (
        <Modal show={showModal} onHide={onHide} backdrop="static" keyboard={false}>
            <Modal.Header>
                <Modal.Title>Add Joint Holder</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Do you want to add joint holder for demat account?</p>
                <p>Please ensure you have the following details ready for the joint holder:</p>
                <ul>
                    <li>PAN details</li>
                    <li>Proof of address (such as Aadhaar, Driving License, Voter ID, or Passport) For KRA compliance</li>
                    <li>Scanned signature</li>
                    <li>Visual verification of the joint holder</li>
                </ul>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    title="No"
                    handleClick={handleNo}
                />
                <Button
                    title="Yes"
                    handleClick={handleYes}
                />
            </Modal.Footer>
        </Modal>
    );
}

export default AddJointHolderModal;
